import {
  DropdownMenuCheckboxItem,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  Icon,
  MoreMenu,
} from "@qw/ui";
import type { FC } from "react";
import { useConversation } from "@/providers/use-conversation";
import { useCoversationMenu } from "@/providers/use-conversation-menu";
import { useDraftsCompose } from "@/providers/use-drafts-compose";

export const ConversationMenu: FC = () => {
  const { displayFooters, displayHeaders, inboxConversation, setDisplayFooters, setDisplayHeaders } = useConversation();
  const { getDraftPlacementForConversation } = useDraftsCompose();

  const { menuItems, isLoading } = useCoversationMenu({
    conversation: inboxConversation,
    draftPlacement: getDraftPlacementForConversation(inboxConversation?.id),
  });

  if (!inboxConversation) {
    return null;
  }

  return (
    <MoreMenu isLoading={isLoading} buttonProps={{ size: "sm" }}>
      {menuItems.length > 0 && (
        <>
          {menuItems.map((item, index) =>
            item.type === "separator" ? (
              <DropdownMenuSeparator key={index} />
            ) : (
              <DropdownMenuItem key={item.id} disabled={item.disabled} onClick={item.onClick}>
                {item.icon && <Icon icon={item.icon} {...item.iconProps} />}
                {item.label}
              </DropdownMenuItem>
            )
          )}
          <DropdownMenuSeparator />
        </>
      )}
      <DropdownMenuLabel>Options</DropdownMenuLabel>
      <DropdownMenuCheckboxItem checked={displayHeaders} onCheckedChange={setDisplayHeaders}>
        Display Headers
      </DropdownMenuCheckboxItem>
      <DropdownMenuCheckboxItem checked={displayFooters} onCheckedChange={setDisplayFooters}>
        Display Footers
      </DropdownMenuCheckboxItem>
    </MoreMenu>
  );
};
